import {useMemo, useEffect} from "react";
import {Navigate, Outlet, useLocation, useNavigate} from "react-router-dom";

const PrivateRoute = () => {
    const location = useLocation();

    const checkAuth = useMemo(() => {
        return (accessToken) => {
            return accessToken;
        };
    }, []);

    const navigate = useNavigate();
    const accessToken = localStorage.getItem("auth_token");

    useEffect(() => {
        if (!checkAuth(accessToken)) {
            localStorage.removeItem("profile");
        }},
        [location, navigate, accessToken]
    );

    return checkAuth(accessToken)
        ? <Outlet /> :  <Navigate to="/signin" /> ;
};

export default PrivateRoute;